import styled from 'styled-components';

export const Container = styled.div`
	padding: 60px 18%;
	background: #f6f2e8;
	@media (max-width: 768px) {
		padding: 60px 5%;
	}
`;

export const Title = styled.p`
	font-size: clamp(1.8rem, 10vw, 3.8rem);
	font-weight: bold;
	margin: 0 10%;
	text-align: center;
	@media (max-width: 768px) {
		margin: 0;
	}
`;

export const Main = styled.p`
	font-size: 1.6rem;
	font-weight: bold;
	margin-top: 60px;
`;

export const Image = styled.div`
	height: 162px;
	width: 250px;

	background: url(/image/aarp-member-offer-logo.png) center no-repeat;
`;

export const Description = styled.p`
	font-size: 1.2em;
`;
